import { createBrowserRouter, RouterProvider, Route, Outlet, Link } from 'react-router-dom'
import {useState} from 'react'
import Home from './pages/Home';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Lottery from './pages/Lottery';
import Contract from './pages/Contract';
import Slots from './pages/Slots';
import { UserProvider } from "./context/UserContext";
import Footer from './components/Footer'
import Header from './components/Header'
//import WalletConnectProvider from "./hooks//WalletConnect";

const Layout = () => {
  return (
    <>
    
      <Outlet />
    <Footer/>
    </>

  )
}


const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        path: '/',
        element: <Home />
      },
      {
        path: '/register',
        element: <Register />
      },
      {
        path: '/dashboard',
        element: <Dashboard />
      },
      {
        path: '/slots',
        element: <Slots />
      },
      {
        path: '/lottery',
        element: <Lottery />
      },
      {
        path: '/contract',
        element: <Contract />
      }
    ]
  }

])



function App() {
  return (
    <div className="app">
      <UserProvider>
        <RouterProvider router={router} />
      </UserProvider>
    </div>
  );
}


export default App;